import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './counterSlice'
import notificationSlice from './notificationSlice'
import signalRConnectionSlice from './signalRConnectionSlice'
import currentUserSlice from './currentUserSlice'

export default configureStore({
    reducer: {
        counter: counterReducer,
        notification: notificationSlice,
        signalRCurrentConnection: signalRConnectionSlice,
        currentUser: currentUserSlice,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})